<template>
  <div class="image-management">
    <el-form label-width="120px">
      <el-form-item label="店铺主页图">
        <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            list-type="picture-card"
            :file-list="mainImages"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="handleMainImageSuccess"
            :limit="3"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="saveSettings">保存设置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ImageManagement',
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      images: JSON.parse(JSON.stringify(this.shop.images || {
        mainImages: []
      })),
      dialogImageUrl: '',
      dialogVisible: false
    }
  },
  computed: {
    mainImages() {
      return this.images.mainImages.map(img => ({
        url: img,
        name: img.split('/').pop()
      }))
    }
  },
  methods: {
    handleRemove(file, fileList) {
      this.images.mainImages = fileList.map(item => item.url || item.response.url)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleMainImageSuccess(response, file, fileList) {
      this.images.mainImages = fileList.map(item => item.url || URL.createObjectURL(item.raw))
    },
    saveSettings() {
      this.$emit('save', this.images)
    }
  }
}
</script>

<style scoped>
.image-management {
  padding: 20px;
}
</style>